import './index.css';
import { jsx } from 'react/jsx-runtime';
import classnames from 'classnames';
import { ScrollableContainer } from '@hh.ru/magritte-ui-scrollable-container';
import { s as styles } from './checkable-card-f8pmdPP2.js';

const CheckableCardScrollableContainer = ({ disableButtons, children, ...containerProps }) => {
    return (jsx(ScrollableContainer, { "data-qa": "checkable-card-scrollable-container", ...containerProps, disableButtons: disableButtons, children: jsx("div", { className: classnames(styles.scrollContainer, { [styles.scrollContainerMobile]: !!disableButtons }), children: children }) }));
};

export { CheckableCardScrollableContainer };
//# sourceMappingURL=CheckableCardContainer.js.map
